<script lang="ts">
    import {onDestroy, onMount} from "svelte";

    export let value = {};

    let visible = false;
    let className = value && value.hasOwnProperty('class') ? value['class'] : '';


    const toggleStyle = () => {
        visible ? hideSelector() : showSelector();
    }

    const showSelector = () => {
        visible = true;
        document.addEventListener('click', clickHandler);
    }

    const hideSelector = () => {
        visible = false;
        document.removeEventListener('click', clickHandler);
    }

    const styles = [
        {className: 'acp-cf-style-success'},
        {className: 'acp-cf-style-warning'},
        {className: 'acp-cf-style-error'},
        {className: 'acp-cf-style-info'},
        {className: 'acp-cf-style-success-invert'},
        {className: 'acp-cf-style-warning-invert'},
        {className: 'acp-cf-style-error-invert'},
        {className: 'acp-cf-style-info-invert'},
    ];

    const setClass = (cls: string) => {
        visible = false;
        className = cls;

        if (typeof value === 'object') {
            value['class'] = cls;
        }

        value = value;
    }

    const clickHandler = () => {
        hideSelector();
    }

    const removeClickHandler = () => {
        document.removeEventListener('click', clickHandler);
    }

    onMount(() => {
        if (value === null) {
            value = {};
        }
    });

    onDestroy(() => {
        removeClickHandler()
    })

</script>
<div on:click|stopPropagation>
	<button on:click|preventDefault={toggleStyle} class={ className }>Abc
	</button>

	{#if visible}
		<div class="acp-cf-style-selector">
			<h3>Formatting style</h3>
			<div>
				{#each styles as style}
					<button class={ style.className } on:click|preventDefault={()=>setClass( style.className )}>Abc</button>
				{/each}
			</div>
		</div>
	{/if}
</div>
<style>

</style>